import { render } from "./ModalAdicionarCanal.vue?vue&type=template&id=aa8f1210&scoped=true"
import script from "./ModalAdicionarCanal.vue?vue&type=script&lang=js"
export * from "./ModalAdicionarCanal.vue?vue&type=script&lang=js"

import "./ModalAdicionarCanal.vue?vue&type=style&index=0&id=aa8f1210&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa8f1210"]])

export default __exports__